import React from "react";

interface IconsProps {
  height: string;
  width: string;
  color: string;
  strokeWidth: string;
}

const NotaDiCreditoIcon = ({ height, width, color, strokeWidth }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} stroke={color} strokeWidth={strokeWidth} viewBox="0 0 61.77 44.339">
      <g id="Group_6" data-name="Group 6" transform="translate(-1181.93 -647.361)">
        <g id="noun_credit_note_2247844" data-name="noun_credit note_2247844" transform="translate(1159 614.911)">
          <g id="_03-Credit_note" data-name="03-Credit note">
            <path
              id="Path_2"
              data-name="Path 2"
              d="M74.69,64.74V33.52a1.07,1.07,0,0,0-1.07-1.07H24a1.07,1.07,0,0,0-1.07,1.07V64.74A1.07,1.07,0,0,0,24,65.81H73.62a1.07,1.07,0,0,0,1.07-1.07Zm-2.14-26H39.67V34.59H72.55Zm-39.89,0V34.59h4.88V38.7Zm4.88,2.14V63.67H32.66V40.84ZM25.08,34.59h5.44V38.7H25.08Zm0,6.25h5.44V63.67H25.08ZM39.67,63.67V40.84H72.55V63.67Z"
            />
            <g id="Group_4" data-name="Group 4" transform="translate(35 -42)">
              <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(22 91.089)" fill="#fff" stroke="#000" strokeWidth="2">
                <circle cx="13.85" cy="13.85" r="13.85" stroke="none" />
                <circle cx="13.85" cy="13.85" r="12.85" fill="none" />
              </g>
              <g id="Group_5" data-name="Group 5" transform="translate(-36 24)">
                <path id="Path_9" data-name="Path 9" d="M77.61,80.08h-12a1.07,1.07,0,0,0,0,2.14h12a1.07,1.07,0,0,0,0-2.14Z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const NotaDiDebitoIcon = ({ height, width, color, strokeWidth }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} stroke={color} strokeWidth={strokeWidth} viewBox="0 0 61.77 44.339">
      <g id="Group_3" data-name="Group 3" transform="translate(-1181.93 -647.361)">
        <g id="noun_credit_note_2247844" data-name="noun_credit note_2247844" transform="translate(1159 614.911)">
          <g id="_03-Credit_note" data-name="03-Credit note">
            <path
              id="Path_2"
              data-name="Path 2"
              d="M74.69,64.74V33.52a1.07,1.07,0,0,0-1.07-1.07H24a1.07,1.07,0,0,0-1.07,1.07V64.74A1.07,1.07,0,0,0,24,65.81H73.62a1.07,1.07,0,0,0,1.07-1.07Zm-2.14-26H39.67V34.59H72.55Zm-39.89,0V34.59h4.88V38.7Zm4.88,2.14V63.67H32.66V40.84ZM25.08,34.59h5.44V38.7H25.08Zm0,6.25h5.44V63.67H25.08ZM39.67,63.67V40.84H72.55V63.67Z"
            />
            <g id="Group_4" data-name="Group 4" transform="translate(35 -42)">
              <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(22 91.089)" fill="#fff" stroke="#000" strokeWidth="2">
                <circle cx="13.85" cy="13.85" r="13.85" stroke="none" />
                <circle cx="13.85" cy="13.85" r="12.85" fill="none" />
              </g>
              <g id="Group_5" data-name="Group 5" transform="translate(-36 24)">
                <path id="Path_9" data-name="Path 9" d="M77.61,80.08h-12a1.07,1.07,0,0,0,0,2.14h12a1.07,1.07,0,0,0,0-2.14Z" />
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M77.61,80.08h-12a1.07,1.07,0,0,0,0,2.14h12a1.07,1.07,0,0,0,0-2.14Z"
                  transform="translate(152.76 9.54) rotate(90)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

const FilterIcon = ({ height, width, color, strokeWidth }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-filter"
    >
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>
  );
};

const ExternalLinkIcon = ({ height, width, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-external-link"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
      <polyline points="15 3 21 3 21 9"></polyline>
      <line x1="10" y1="14" x2="21" y2="3"></line>
    </svg>
  );
};

const PrinterIcon = ({ height, width, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 256 256"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-printer"
    >
      <path d="M216,72H130.67L102.93,51.2a16.12,16.12,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72Zm0,128H40V64H93.33l27.74,20.8a16.12,16.12,0,0,0,9.6,3.2H216Z"></path>
    </svg>
  );
};

const SupplierPrinterIcon = ({ height, width, color }) => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 256 256"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-supplier-printer"
    >
      <path d="M231.73,221.94A8,8,0,0,1,224,232H160A8,8,0,0,1,152.27,222a40,40,0,0,1,17.11-23.33,32,32,0,1,1,45.24,0A40,40,0,0,1,231.73,221.94ZM216,72H130.67L102.93,51.2a16.12,16.12,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16h80a8,8,0,0,0,0-16H40V64H93.33l27.74,20.8a16.12,16.12,0,0,0,9.6,3.2H216v32a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72Z"></path>
    </svg>
  );
};

const AlertCircleIcon = ({ height, width, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-alert-circle"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  );
};

const CodeIcon = ({ height, width, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-code"
    >
      <polyline points="16 18 22 12 16 6"></polyline>
      <polyline points="8 6 2 12 8 18"></polyline>
    </svg>
  );
};

const CopyIcon = ({ height, width, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-copy"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>
  );
};

const XmlFileIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22">
      <g transform="translate(-1135 -728)">
        <g transform="translate(1132 727)">
          <path
            d="M13,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V9Z"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path d="M13,2V9h7" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        </g>
        <g transform="translate(1141 738)" stroke="#000" strokeWidth="0.5">
          <rect width="19" height="9" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="18" height="8" rx="1.5" fill="none" />
        </g>
        <text transform="translate(1142.5 745)" fill="#fff" fontSize="7" fontFamily="Montserrat-Black, Montserrat" fontWeight="700">
          <tspan x="0" y="0">
            XML
          </tspan>
        </text>
      </g>
    </svg>
  );
};

const XlsFileIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22">
      <g transform="translate(-1135 -728)">
        <g transform="translate(1132 727)">
          <path
            d="M13,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V9Z"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path d="M13,2V9h7" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        </g>
        <g transform="translate(1141 738)" stroke="#000" strokeWidth="0.5">
          <rect width="19" height="9" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="18" height="8" rx="1.5" fill="none" />
        </g>
        <text transform="translate(1142.5 745)" fill="#fff" fontSize="7" fontFamily="Montserrat-Black, Montserrat" fontWeight="700">
          <tspan x="0" y="0">
            XLS
          </tspan>
        </text>
      </g>
    </svg>
  );
};

const CsvFileIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 25 22">
      <g transform="translate(-1135 -728)">
        <g transform="translate(1132 727)">
          <path
            d="M13,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V9Z"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path d="M13,2V9h7" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        </g>
        <g transform="translate(1141 738)" stroke="#000" strokeWidth="0.5">
          <rect width="19" height="9" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="18" height="8" rx="1.5" fill="none" />
        </g>
        <text transform="translate(1142.5 745)" fill="#fff" fontSize="7" fontFamily="Montserrat-Black, Montserrat" fontWeight="700">
          <tspan x="0" y="0">
            CSV
          </tspan>
        </text>
      </g>
    </svg>
  );
};


const PdfFileIcon = ({ color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22">
      <g transform="translate(-1135 -728)">
        <g transform="translate(1132 727)">
          <path
            d="M13,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V9Z"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path d="M13,2V9h7" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        </g>
        <g transform="translate(1141 738)" stroke={color} strokeWidth="0.5">
          <rect width="19" height="9" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="18" height="8" rx="1.5" fill="none" />
        </g>
        <text transform="translate(1143 745)" fill="#fff" fontSize="7" fontFamily="Montserrat-Black, Montserrat" fontWeight="700">
          <tspan x="0" y="0">
            PDF
          </tspan>
        </text>
      </g>
    </svg>
  );
};

const FileIcon = ({ height, width, color, strokeWidth }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-file"
    >
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
      <polyline points="13 2 13 9 20 9"></polyline>
    </svg>
  );
};

const SendIcon = ({ height, width, color, strokeWidth }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-send"
    >
      <line x1="22" y1="2" x2="11" y2="13"></line>
      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>
  );
};
const TruckIcon = ({ height, width, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-truck"
    >
      <rect x="1" y="3" width="15" height="13"></rect>
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
      <circle cx="5.5" cy="18.5" r="2.5"></circle>
      <circle cx="18.5" cy="18.5" r="2.5"></circle>
    </svg>
  );
};

const FileTextIcon = ({ height, width, color, strokeWidth }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-file-text"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  );
};

const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#2FBE86"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-check"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );
};

function TrashIcon({ width, height, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-trash-2"
    >
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  );
}

function CreditCardIcon({ width, height, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-credit-card"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>
  );
}

function PackageIcon({ width, height, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-package"
    >
      <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line>
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
      <line x1="12" y1="22.08" x2="12" y2="12"></line>
    </svg>
  );
}

function PhoneIcon({ width, height, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-phone"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
    </svg>
  );
}

function RefreshCcwIcon({ width, height, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-refresh-ccw"
    >
      <polyline points="1 4 1 10 7 10"></polyline>
      <polyline points="23 20 23 14 17 14"></polyline>
      <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
    </svg>
  );
}

function CashOnDeliveryIcon({ width, height, color, strokeWidth }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" className="feather feather-cash-on-delivery">
      <g transform="translate(-7 -5.786)">
        <g transform="translate(7 5.786)">
          <path
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M35.976,10.125a.55.55,0,0,0-.312-.282l-1.788-.651a25.339,25.339,0,0,0-3.157-2.367,12.75,12.75,0,0,0-2.463-.748.525.525,0,0,0-.167-.188.574.574,0,0,0-.416-.1L14.457,7.836a.562.562,0,0,0-.371.212.523.523,0,0,0-.1.4L15.1,15.1a.553.553,0,0,0,.558.452.532.532,0,0,0,.092,0l8.214-1.3a.541.541,0,0,0,.46-.619.556.556,0,0,0-.642-.444L16.108,14.4,15.179,8.8,27.293,6.919l.636,3.911-1.2.035a.614.614,0,0,0-.153.027l-1.718.538a.54.54,0,0,0-.385.522,5.488,5.488,0,0,0,.128,1.3,4.193,4.193,0,0,0,.594.861.57.57,0,0,0,.558.183l2.206-.5,1.431.132L31.3,15a.543.543,0,0,0,.2.124l.084.03h0a.534.534,0,0,0,.167.056l1.565.573a.6.6,0,0,0,.2.035.559.559,0,0,0,.555-.35L36,10.537A.52.52,0,0,0,35.976,10.125Zm-6.354,2.733-1.643-.148a.578.578,0,0,0-.179,0l-1.952.444a2.608,2.608,0,0,1-.192-.269,4.2,4.2,0,0,1-.053-.565l1.244-.39,1.757-.054h.089l.056-.013a.214.214,0,0,0,.05-.019l.05-.022L28.9,11.8l.042-.032.039-.032.036-.04.033-.04.025-.046.025-.043.017-.051.017-.051a.288.288,0,0,0,0-.051.352.352,0,0,0,0-.054V11.33a.132.132,0,0,0,0-.035v-.032l-.669-4.035a9.9,9.9,0,0,1,1.74.554,23.055,23.055,0,0,1,2.764,2.077l-1.54,3.946-1.579-.877A.613.613,0,0,0,29.622,12.858Zm3.587,1.721-.781-.285,1.54-3.919.781.285Z"
            transform="translate(-12.03 -5.786)"
          />
          <path
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M37.462,16.545a2.332,2.332,0,0,0-2.684-.079,2.144,2.144,0,0,0-.875,2.449,2.257,2.257,0,0,0,2.165,1.533,2.376,2.376,0,0,0,.279-.016,2.242,2.242,0,0,0,1.9-1.585,2.14,2.14,0,0,0-.786-2.3Zm-.494,2.4a1.174,1.174,0,0,1-1.351.33,1.1,1.1,0,0,1-.683-1.171,1.127,1.127,0,0,1,.993-.942h.139a1.153,1.153,0,0,1,1.03.625,1.076,1.076,0,0,1-.129,1.167Z"
            transform="translate(-26.324 -13.311)"
          />
          <path
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M24.6,69.623a1.144,1.144,0,0,0-1.5-.231l-1.1.538-2.625.584a2.081,2.081,0,0,0-.181-.565,4.219,4.219,0,0,0-.823-.807.573.573,0,0,0-.5-.11l-2.745.681-1.891-.024-2.789-1.038v-.441A.548.548,0,0,0,9.9,67.67H7.558A.548.548,0,0,0,7,68.208v6.275a.548.548,0,0,0,.558.538H9.881a.548.548,0,0,0,.558-.538v-.508l5.375,1.046a.505.505,0,0,0,.112,0A.6.6,0,0,0,16.093,75l4.415-1.345.045-.016,2.789-1.122a.525.525,0,0,0,.151-.089l1.163-.963a1.112,1.112,0,0,0,.156-1.584ZM9.323,73.945H8.116v-5.2H9.323Zm14.607-3.3-1.1.906L20.148,72.63l-4.256,1.3-5.453-1.06V69.8l2.51.928a.576.576,0,0,0,.192.035l2.064.027a.536.536,0,0,0,.145-.019l2.527-.627a3.291,3.291,0,0,1,.351.339,3.57,3.57,0,0,1,.1.5l-1.6.514-1.579.218a.546.546,0,0,0-.519.576.553.553,0,0,0,.6.5h.081l1.626-.226a.394.394,0,0,0,.1-.022l2.092-.672a.537.537,0,0,0,.3-.237l2.9-.651a.754.754,0,0,0,.131-.046l1.191-.594a.191.191,0,0,0,.081-.04l.212.269A.068.068,0,0,1,23.931,70.648Z"
            transform="translate(-7 -51.024)"
          />
          <path
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M32.483,53.338a.548.548,0,0,0,.558-.538V45.538A.548.548,0,0,0,32.483,45H23.558a.548.548,0,0,0-.558.538V51.7a.558.558,0,0,0,1.116,0V46.076h2.256l.05,3.273a.535.535,0,0,0,.279.463.574.574,0,0,0,.279.067.542.542,0,0,0,.279-.078l.806-.471.817.449a.576.576,0,0,0,.562,0,.534.534,0,0,0,.274-.474l-.047-3.228h2.254V52.8A.548.548,0,0,0,32.483,53.338Zm-4.145-5.111a.576.576,0,0,0-.558,0l-.251.145L27.5,46.138l1.071-.016.033,2.235Z"
            transform="translate(-18.537 -34.452)"
          />
        </g>
      </g>
    </svg>
  );
}

function BankIcon({ width, height, color, strokeWidth }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" className="feather feather-bank">
      <g id="Group_1" data-name="Group 1" transform="translate(-705.565 -236)">
        <g id="Bank" transform="translate(705.565 236)">
          <path
            id="Path_1"
            data-name="Path 1"
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M80.688-576.661,74.7-572.422l6,.015c3.3.005,8.7.005,12,0l6-.015-6-4.244c-3.3-2.33-6-4.239-6.007-4.234S83.983-578.991,80.688-576.661Zm6.365-.537a1.337,1.337,0,0,1,.793,1.155,1.241,1.241,0,0,1-1.146,1.215,1.019,1.019,0,0,1-.788-.38,1.18,1.18,0,0,1-.01-1.686A1.065,1.065,0,0,1,87.053-577.2Z"
            transform="translate(-74.7 580.9)"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M122-389.379v5.621h2.292V-395H122Z"
            transform="translate(-119.741 404.415)"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M242-389.379v5.621h2.292V-395H242Z"
            transform="translate(-234.011 404.415)"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M362-389.379v5.621h2.292V-395H362Z"
            transform="translate(-348.281 404.415)"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M482-389.379v5.621h2.292V-395H482Z"
            transform="translate(-462.551 404.415)"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            fill={color}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M86-153.785v1.215h22.921V-155H86Z"
            transform="translate(-85.46 176.569)"
          />
        </g>
      </g>
    </svg>
  );
}

function SlidersIcons() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-sliders"
    >
      <line x1="4" y1="21" x2="4" y2="14"></line>
      <line x1="4" y1="10" x2="4" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12" y2="3"></line>
      <line x1="20" y1="21" x2="20" y2="16"></line>
      <line x1="20" y1="12" x2="20" y2="3"></line>
      <line x1="1" y1="14" x2="7" y2="14"></line>
      <line x1="9" y1="8" x2="15" y2="8"></line>
      <line x1="17" y1="16" x2="23" y2="16"></line>
    </svg>
  );
}

function DeleteIconCircle({ width, height, className, backgroundColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" className={`feather feather-delete-circle` + ' ' + className}>
      <g id="DeleteCircleIcon" transform="translate(-1549.101 -249.101)">
        <path id="Path_33" data-name="Path 33" d="M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z" transform="translate(1549.101 249.101)" fill={backgroundColor} />
        <g id="plus" transform="translate(1558 241.029) rotate(45)">
          <line
            id="Line_22"
            data-name="Line 22"
            y2="14"
            transform="translate(12 5)"
            fill="none"
            stroke="#fff"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="1.8"
          />
          <line
            id="Line_23"
            data-name="Line 23"
            x2="14"
            transform="translate(5 12)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.8"
          />
        </g>
      </g>
    </svg>
  );
}

function CheckCircleIcon2({ width, height, backgroundColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 28">
      <g id="Group_1" data-name="Group 1" transform="translate(-874 -712)">
        <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(874 712)" stroke={backgroundColor} strokeWidth="1.5">
          <circle cx="14" cy="14" r="14" stroke="none" />
          <circle cx="14" cy="14" r="13.25" fill={backgroundColor} />
        </g>
        <path
          id="check"
          d="M20,6,9,17,4,12"
          transform="translate(876 714.5)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
}

function DeleteIconCross({ width, height, color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" className={`feather feather-delete-cross`}>
      <g id="Group_216" data-name="Group 216" transform="translate(-1556 -252)">
        <g id="plus" transform="translate(1565 244.029) rotate(45)">
          <line
            id="Line_22"
            data-name="Line 22"
            y2="14"
            transform="translate(12 5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.8"
          />
          <line
            id="Line_23"
            data-name="Line 23"
            x2="14"
            transform="translate(5 12)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.8"
          />
        </g>
      </g>
    </svg>
  );
}

function DownloadIcon({ width, height }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-download">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
  );
}

function DeleteIcon({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-delete"
    >
      <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path>
      <line x1="18" y1="9" x2="12" y2="15"></line>
      <line x1="12" y1="9" x2="18" y2="15"></line>
    </svg>
  );
}

function CrediCardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-credit-card"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>
  );
}

function ChevronLeftIcon({ width, height, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-chevron-left"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );
}

function ChevronRightIcon({ width, height, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-chevron-right"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );
}

function LogOutIcon({ width, height, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-log-out"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
      <polyline points="16 17 21 12 16 7"></polyline>
      <line x1="21" y1="12" x2="9" y2="12"></line>
    </svg>
  );
}

function EyeOffIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-eye-off"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
      <line x1="1" y1="1" x2="23" y2="23"></line>
    </svg>
  );
}

function EyeIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-eye"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  );
}

function PlusIcon({ width, height, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-plus"
    >
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  );
}

function ChevronUpIcon({ height, width, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-chevron-up"
    >
      <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
  );
}

function ChevronDownIcon({ height, width, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-chevron-down"
    >
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  );
}

function HomeIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-home"
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9 22 9 12 15 12 15 22"></polyline>
    </svg>
  );
}

function XIcon({ height, width, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-x"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
}

function EditIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-edit"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  );
}

function Edit2Icon({ height, width, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-edit-2"
    >
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
    </svg>
  );
}

function Edit3Icon({ height, width, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-edit-3"
    >
      <path d="M12 20h9"></path>
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
    </svg>
  );
}

function FilePlusIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-file-plus"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="12" y1="18" x2="12" y2="12"></line>
      <line x1="9" y1="15" x2="15" y2="15"></line>
    </svg>
  );
}
function ListIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-list"
    >
      <line x1="8" y1="6" x2="21" y2="6"></line>
      <line x1="8" y1="12" x2="21" y2="12"></line>
      <line x1="8" y1="18" x2="21" y2="18"></line>
      <line x1="3" y1="6" x2="3.01" y2="6"></line>
      <line x1="3" y1="12" x2="3.01" y2="12"></line>
      <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>
  );
}

function CheckCircleIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-check-circle"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
  );
}

function ArrowLeftIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-arrow-left"
    >
      <line x1="19" y1="12" x2="5" y2="12"></line>
      <polyline points="12 19 5 12 12 5"></polyline>
    </svg>
  );
}

function ArrowRightIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-arrow-right"
    >
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
  );
}

function YoutubeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-youtube"
    >
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
      <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-instagram"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>
  );
}

function TwitterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-twitter"
    >
      <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
    </svg>
  );
}

function WhatsAppIcon({ width, height, color, strokeWidth }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height={height} width={width} stroke={color} strokeWidth={strokeWidth}>
      {" "}
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-facebook"
    >
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
    </svg>
  );
}

function MinusIcon({ width, height, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-minus"
    >
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  );
}

function SmallProductIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" className="feather feather-smallproduct">
      <g id="smallproduct" data-name="smallproduct" transform="translate(-1864 -520)">
        <g id="Rectangle_26" data-name="Rectangle 26" transform="translate(1864 520)" fill="none" stroke="#222" strokeWidth="1">
          <rect width="8" height="8" stroke="none" />
          <rect x="0.5" y="0.5" width="7" height="7" fill="none" />
        </g>
        <g id="Rectangle_27" data-name="Rectangle 27" transform="translate(1874 520)" fill="none" stroke="#222" strokeWidth="1">
          <rect width="8" height="8" stroke="none" />
          <rect x="0.5" y="0.5" width="7" height="7" fill="none" />
        </g>
        <g id="Rectangle_28" data-name="Rectangle 28" transform="translate(1874 530)" fill="none" stroke="#222" strokeWidth="1">
          <rect width="8" height="8" stroke="none" />
          <rect x="0.5" y="0.5" width="7" height="7" fill="none" />
        </g>
        <g id="Rectangle_29" data-name="Rectangle 29" transform="translate(1864 530)" fill="#fff" stroke="#222" strokeWidth="1">
          <rect width="8" height="8" stroke="none" />
          <rect x="0.5" y="0.5" width="7" height="7" fill="none" />
        </g>
      </g>
    </svg>
  );
}

function BigProductIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" className="feather feather-bigproduct">
      <g id="Rectangle_24" data-name="Rectangle 24" fill="none" stroke="#000" strokeWidth="1">
        <rect width="18" height="18" stroke="none" />
        <rect x="0.5" y="0.5" width="17" height="17" fill="none" />
      </g>
    </svg>
  );
}

function SlidersIcon({ width, height, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-sliders"
    >
      <line x1="4" y1="21" x2="4" y2="14"></line>
      <line x1="4" y1="10" x2="4" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12" y2="3"></line>
      <line x1="20" y1="21" x2="20" y2="16"></line>
      <line x1="20" y1="12" x2="20" y2="3"></line>
      <line x1="1" y1="14" x2="7" y2="14"></line>
      <line x1="9" y1="8" x2="15" y2="8"></line>
      <line x1="17" y1="16" x2="23" y2="16"></line>
    </svg>
  );
}

function BurgerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-menu"
    >
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  );
}

function HeartIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`feather feather-heart ${className}`}
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
  );
}

function MoreHorizontalIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="6" viewBox="0 0 34 8" className="feather more-horizontal">
      <g id="Group_6" data-name="Group 6" transform="translate(-306 129)">
        <circle
          id="circle"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(306.5 -128.5)"
          fill="none"
          stroke="#23262c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <circle
          id="circle-2"
          data-name="circle"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(319.5 -128.5)"
          fill="none"
          stroke="#23262c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <circle
          id="circle-3"
          data-name="circle"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(332.5 -128.5)"
          fill="none"
          stroke="#23262c"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}

function SearchIcon({ height, width, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-search"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  );
}

function ShoppingbagIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-shopping-bag"
    >
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <path d="M16 10a4 4 0 0 1-8 0"></path>
    </svg>
  );
}

function UserIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-user"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  );
}

function UserPlusIcon({ height, width, color, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-user-plus"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="8.5" cy="7" r="4"></circle>
      <line x1="20" y1="8" x2="20" y2="14"></line>
      <line x1="23" y1="11" x2="17" y2="11"></line>
    </svg>
  );
}

const Spinner = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg viewBox="0 0 100 100" {...props}>
      <path d="M90.9 58.2c-3.8 18.9-20.1 32.7-39.7 33-22 .4-40.7-17-41.9-39C8 28.5 26.9 8.8 50.4 8.8c19 0 35.5 13.1 40 31.2.3 1.2 1.4 2.1 2.7 2.1 1.8 0 3.1-1.7 2.7-3.5C90.6 18.1 72 3.3 50.4 3.3c-27.2 0-49 23.4-46.6 51.1 2.1 23 21 41.2 44 42.4C71.6 98 91.7 81.9 96.2 59.4c.3-1.7-1-3.3-2.7-3.3-1.3-.1-2.4.8-2.6 2.1z" />
    </svg>
  );
};

const ProductTag = ({ width, height, color }): JSX.Element => {
  return (
    <svg
      viewBox="0 0 500 500"
      height={height}
      width={width}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className="feather feather-product-tag"
    >
      <g>
        <path
          d="M352.806,234.798L250.268,132.26l14.588-14.588L367.394,220.21L352.806,234.798z M297.845,289.758L195.308,187.221
		l14.588-14.588L312.434,275.17L297.845,289.758z M242.886,344.717L140.348,242.179l14.589-14.589l102.538,102.538L242.886,344.717z
		 M187.92,399.681L85.381,297.142l14.589-14.589l102.539,102.539L187.92,399.681z"
        />
        <path
          d="M472.587,12.57c-8.019-8.044-18.689-12.472-30.175-12.472L303.599,0.526c-11.29,0.035-21.899,4.448-29.868,12.427
		L12.499,274.179c-23.585,25.623-8.014,51.987,0,59.997l138.386,138.386c25.746,23.135,51.988,8.014,59.997,0l261.227-261.227
		c7.979-7.979,12.392-18.588,12.427-29.873l0.428-138.813C485,31.295,480.602,20.615,472.587,12.57z M463.902,181.403
		c-0.014,5.793-2.282,11.243-6.382,15.344L196.294,457.973c-8.232,8.232-22.589,8.232-30.82,0L27.088,319.587
		c-4.115-4.116-12.072-18.591,0-30.82L288.325,27.542c4.091-4.101,9.541-6.368,15.334-6.382l138.884-0.428
		c5.834,0,11.309,2.277,15.43,6.406c4.116,4.131,6.378,9.618,6.357,15.451L463.902,181.403z"
        />
        <path
          d="M390.665,54.113c-22.248,0-40.283,18.035-40.283,40.283s18.035,40.283,40.283,40.283s40.283-18.035,40.283-40.283
		S412.913,54.113,390.665,54.113z M390.665,114.438c-11.069,0-20.041-8.973-20.041-20.042s8.973-20.042,20.041-20.042
		s20.041,8.973,20.041,20.042S401.733,114.438,390.665,114.438z"
        />
      </g>
    </svg>
  );
};

export {
  AlertCircleIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  BankIcon,
  BigProductIcon,
  BurgerIcon,
  CashOnDeliveryIcon,
  CheckCircleIcon,
  CheckCircleIcon2,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  CodeIcon,
  CopyIcon,
  CrediCardIcon,
  CreditCardIcon,
  DeleteIcon,
  DeleteIconCircle,
  DeleteIconCross,
  DownloadIcon,
  Edit2Icon,
  Edit3Icon,
  EditIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FacebookIcon,
  FileIcon,
  FilePlusIcon,
  FileTextIcon,
  FilterIcon,
  HeartIcon,
  HomeIcon,
  InstagramIcon,
  ListIcon,
  LogOutIcon,
  MinusIcon,
  MoreHorizontalIcon,
  NotaDiCreditoIcon,
  NotaDiDebitoIcon,
  PackageIcon,
  PdfFileIcon,
  PhoneIcon,
  PlusIcon,
  PrinterIcon,
  ProductTag,
  RefreshCcwIcon,
  SearchIcon,
  SendIcon,
  ShoppingbagIcon,
  SlidersIcon,
  SlidersIcons,
  SmallProductIcon,
  Spinner,
  SupplierPrinterIcon,
  TrashIcon,
  TruckIcon,
  TwitterIcon,
  UserIcon,
  UserPlusIcon,
  WhatsAppIcon,
  XIcon,
  XmlFileIcon,
  XlsFileIcon,
  CsvFileIcon,
  YoutubeIcon,
};
